import { px } from '../utils/px';
import color from './color';

export const spacingUnitInt = 5; // 1 spacing unit = 5px as per design
export const defaultBorder = `${px(1)} solid ${color.border}`;
export const tableBorder = `${px(1)} solid ${color.tableBorder}`;

export const defaultBorderRadius = px(5);
